import React from 'react';

import {
  Grid,
  Button,
  Dialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle,
  styled
} from '@mui/material';
import {
  fields,
  appEvents,
  enumCache,
  FundingStageSelectField
} from 'modules';

import * as dataService from './dataService';



const ControlledTextField = fields.genTextFieldControllerComponent<dataService.IFormData>();
const FundingStageSelectFieldController = fields.genEnumSelectFieldControllerComponent<dataService.IFormData, enumCache.IFundingStage>(FundingStageSelectField({
  label: 'Investment Stage'
}));



const DialogActions = styled(MuiDialogActions)({
  margin: '32px 0 8px 0',
  padding: '8px 24px 8px 24px'
});



const DialogContent = styled(MuiDialogContent)({
  maxWidth: 720
});



export interface IProps {
  mode?: 'edit' | 'create';
  campaignId?: string;

  onSubmitted?: () => void;
}

export const FC: React.FC<IProps> = props => {
  const {
    form,
    loading,
    mutations
  } = dataService.useFundraisingCampaignModal(props.campaignId);
  const characters = form.watch('fundraiseDescription');



  async function processSubmit(data: dataService.IFormData) {
    try {
      await mutations.saveCampaignMutation(data);
      if (props.onSubmitted) {
        props.onSubmitted();
      }

    } catch (e) {
      alert(e);

    } finally {
      handleClose();
    }
  }



  function handleClose() {
    appEvents.broadcast({
      type: 'modal',
      args: 'close'
    });
  }



  return (
    <Dialog
      open
      onClose={handleClose}
      maxWidth="md">
      <DialogTitle>
        {
          props.mode === 'create'
            ? 'Create A Fundraise'
            : 'Edit Fundraise'
        }
      </DialogTitle>

      <form onSubmit={form.handleSubmit(processSubmit)}>
        <DialogContent>
          <Grid
            container
            spacing={3}>
            <Grid item xs={12}>
              <ControlledTextField
                formControl={form.control}
                label="Fundraise Name"
                fieldKey="fundraiseName" />
            </Grid>

            <Grid item xs={12}>
              <ControlledTextField
                type="text"
                numLines={6}
                characterCount={characters?.length ?? 0}
                formControl={form.control}
                label="Fundraise Description"
                fieldKey="fundraiseDescription" />
            </Grid>

            <Grid item xs={4}>
              <ControlledTextField
                type='date'
                formControl={form.control}
                label="Target Close Date (optional)"
                fieldKey="targetCloseDate" />
            </Grid>

            <Grid item xs={4}>
              <ControlledTextField
                type='number'
                formControl={form.control}
                label="Target Dollar Amount ($)"
                fieldKey="targetAmountDollars" />
            </Grid>

            <Grid item xs={4}>
              <FundingStageSelectFieldController
                formControl={form.control}
                fieldKey="fundingStage" />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            disabled={loading}
            variant="outlined"
            color="secondary"
            onClick={handleClose}>
            Cancel
          </Button>

          <Button
            type="submit"
            disabled={loading}>
            Confirm
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
